import { useState } from "react";
import back5 from "../../../../imgs/back5.png";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Main from "./main";
import Nav from "../../vendor/navbar";
import ErrorModal from "../../../Merchant/Modals/errorModal";
import SuccessModal from "../../../modals/successModal";
const Mid = () => {
  const router = useNavigate();
  const user = useSelector((state) => state.user);
  const [showAddTier, setShowAddTier] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [err, setErr] = useState("");
  const [refetch, setRefetch] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  return (
    <>
      <div className="bg-[#D9EFED]  min-h-screen">
        <Nav />
        <div
          className={`${
            user === "vendor-owner"
              ? "flex items-center justify-center bg-[#D9EFED]"
              : "flex items-center justify-center"
          }`}
        >
          <div className="md:w-[95%] mt-[1rem] rounded-md w-[95%] sm:px-20 px-4">
            <div className="cursor-pointer flex w-full items-center justify-center">
              <img
                onClick={() => router("/Inventory-AddProduct")}
                className="sm:w-[1.7rem] w-[1.3rem]"
                src={back5}
                alt=""
              />
              <h2 className="font-bold w-full sm:text-[1.8rem] sm:ml-2 ml-[1rem] text-[1.4rem]">
                Discount History
              </h2>
            </div>

            <Main />
          </div>
        </div>
      </div>

      {showErrorModal && (
        <ErrorModal show={showErrorModal} setShow={setShowErrorModal} />
      )}

      {showSuccessModal && (
        <SuccessModal
          setShow={setShowSuccessModal}
          message={err}
          route={"/Inventory/AddProduct/AddTier"}
        />
      )}
    </>
  );
};

export default Mid;
